/* Theme JS — RC Shopper */
(function () {
  // Mobile nav
  const burger = document.querySelector('[data-mobile-nav-toggle]');
  const nav = document.querySelector('.hd-nav');
  if (burger && nav) {
    burger.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open);
    });
  }

  // PDP — thumb swap
  document.querySelectorAll('.pdp-thumb').forEach(t => {
    t.addEventListener('click', () => {
      const main = document.getElementById('pdp-main-img');
      if (main) main.src = t.dataset.thumb;
      document.querySelectorAll('.pdp-thumb').forEach(x => x.classList.remove('is-active'));
      t.classList.add('is-active');
    });
  });

  // PDP — variant select via radio options
  const productForm = document.getElementById('product-form');
  if (productForm) {
    const variantSelect = productForm.querySelector('#variant-select');
    productForm.querySelectorAll('input[type="radio"][name^="options"]').forEach(r => {
      r.addEventListener('change', () => {
        const opts = [...productForm.querySelectorAll('input[type="radio"]:checked')].map(x => x.value);
        const variant = JSON.parse(productForm.dataset.variants || 'null') || null;
        // simple: rely on Shopify's options[] form post; pick first matching variant title
        if (variantSelect) {
          for (const o of variantSelect.options) {
            if (opts.every(v => o.text.includes(v))) { variantSelect.value = o.value; break; }
          }
        }
      });
    });
  }

  // PDP — qty stepper
  document.querySelectorAll('[data-qty]').forEach(b => {
    b.addEventListener('click', () => {
      const inp = document.getElementById('qty-input');
      if (!inp) return;
      const cur = Math.max(1, parseInt(inp.value || '1', 10));
      inp.value = cur + (b.dataset.qty === '+1' ? 1 : -1);
      if (parseInt(inp.value, 10) < 1) inp.value = 1;
    });
  });
})();
